import { render, staticRenderFns } from "./Graph2.vue?vue&type=template&id=3cebf87c"
import script from "./Graph2.vue?vue&type=script&lang=js"
export * from "./Graph2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cebf87c')) {
      api.createRecord('3cebf87c', component.options)
    } else {
      api.reload('3cebf87c', component.options)
    }
    module.hot.accept("./Graph2.vue?vue&type=template&id=3cebf87c", function () {
      api.rerender('3cebf87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/Graph2.vue"
export default component.exports